import { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { LanguageOptions } from '../../entities/LanguageOptions';
import { UploadPicture } from '../../features/UploadPicture';
import { apiRequests } from '../../shared/api/apiRequests';
import { toast } from 'react-toastify';
import './Team.css';

const EditTeamMemberPage = () => {
  const { structureId, id, memberId } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [mainImage, setMainImage] = useState(null);
  const [form, setForm] = useState({
    id: 0,
    name: '',
    surname: '',
    position: '',
    mainLanguageId: 1,
    shortExpierence: '',
    quote: '',
    SEOMetatags: {
      Title: '',
      Description: '',
      Keywords: '',
    },
  });

  useEffect(() => {
    loadMember();
  }, [id, memberId]);

  const loadMember = async () => {
    try {
      setLoading(true);
      const response = await apiRequests.team.getMember(id, memberId);
      setForm({
        id: response.id,
        name: response.name || '',
        surname: response.surname || '',
        position: response.position || '',
        mainLanguageId: response.mainLanguageId || 1,
        shortExpierence: response.shortExpierence || '',
        quote: response.quote || '',
        SEOMetatags: {
          Title: response.seoMetatags?.title || '',
          Description: response.seoMetatags?.description || '',
          Keywords: response.seoMetatags?.keywords || '',
        },
      });
    } catch {
      toast.error('Ошибка загрузки участника');
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.name.trim() || !form.surname.trim()) {
      toast.error('Введите имя и фамилию');
      return;
    }
    setSaving(true);
    try {
      const body = new FormData();
      if (mainImage) {
        body.append('mainImg', mainImage);
      }
      body.append('model', JSON.stringify(form));
      await apiRequests.team.updateMember(body);
      toast.success('Участник обновлён');
      navigate(`/team-structures/${structureId}/group/${id}`);
    } catch {
      toast.error('Ошибка сохранения');
    } finally {
      setSaving(false);
    }
  };

  const handleBack = () => navigate(`/team-structures/${structureId}/group/${id}`);

  if (loading) {
    return <div className="team-loading">Загрузка...</div>;
  }

  return (
    <div className="team-page">
      <div className="team-header">
        <div>
          <button className="team-back" onClick={handleBack}>← Назад</button>
          <h1 className="team-title">Редактирование участника</h1>
        </div>
      </div>

      <form onSubmit={handleSubmit} className="team-form">
        <div className="team-form-section">
          <h3 className="team-section-title">Основная информация</h3>
          <div className="team-form-row">
            <div className="team-form-field">
              <label>Имя <span className="required">*</span></label>
              <input
                type="text"
                value={form.name}
                onChange={(e) => setForm((prev) => ({ ...prev, name: e.target.value }))}
                placeholder="Введите имя"
                className="team-input"
              />
            </div>
            <div className="team-form-field">
              <label>Фамилия <span className="required">*</span></label>
              <input
                type="text"
                value={form.surname}
                onChange={(e) => setForm((prev) => ({ ...prev, surname: e.target.value }))}
                placeholder="Введите фамилию"
                className="team-input"
              />
            </div>
          </div>

          <div className="team-form-row">
            <div className="team-form-field">
              <label>Должность</label>
              <input
                type="text"
                value={form.position}
                onChange={(e) => setForm((prev) => ({ ...prev, position: e.target.value }))}
                placeholder="UI/UX Designer"
                className="team-input"
              />
            </div>
            <div className="team-form-field">
              <label>Опыт работы</label>
              <input
                type="text"
                value={form.shortExpierence}
                onChange={(e) => setForm((prev) => ({ ...prev, shortExpierence: e.target.value }))}
                placeholder="5 лет"
                className="team-input"
              />
            </div>
          </div>

          <div className="team-form-row">
            <div className="team-form-field">
              <label>Цитата</label>
              <textarea
                value={form.quote}
                onChange={(e) => setForm((prev) => ({ ...prev, quote: e.target.value }))}
                placeholder="Введите цитату"
                className="team-textarea"
              />
            </div>
          </div>

          <div className="team-form-row">
            <div className="team-form-field" style={{ maxWidth: 200 }}>
              <LanguageOptions
                value={form.mainLanguageId}
                onSelect={(val) => setForm((prev) => ({ ...prev, mainLanguageId: val }))}
              />
            </div>
          </div>

          <div className="team-form-row">
            <div className="team-form-field">
              <label>Фото</label>
              <UploadPicture onSelect={setMainImage} entityType="team" />
            </div>
          </div>
        </div>

        <div className="team-form-section" style={{ borderTop: '1px solid #f0f0f0' }}>
          <h3 className="team-section-title">SEO настройки</h3>
          <div className="team-form-row">
            <div className="team-form-field">
              <label>SEO Title</label>
              <input
                type="text"
                value={form.SEOMetatags.Title}
                onChange={(e) => setForm((prev) => ({
                  ...prev,
                  SEOMetatags: { ...prev.SEOMetatags, Title: e.target.value },
                }))}
                placeholder="Заголовок для поисковиков"
                className="team-input"
              />
            </div>
          </div>
          <div className="team-form-row">
            <div className="team-form-field">
              <label>SEO Description</label>
              <textarea
                value={form.SEOMetatags.Description}
                onChange={(e) => setForm((prev) => ({
                  ...prev,
                  SEOMetatags: { ...prev.SEOMetatags, Description: e.target.value },
                }))}
                placeholder="Описание для поисковиков"
                className="team-textarea"
              />
            </div>
          </div>
          <div className="team-form-row">
            <div className="team-form-field">
              <label>SEO Keywords</label>
              <input
                type="text"
                value={form.SEOMetatags.Keywords}
                onChange={(e) => setForm((prev) => ({
                  ...prev,
                  SEOMetatags: { ...prev.SEOMetatags, Keywords: e.target.value },
                }))}
                placeholder="Ключевые слова через запятую"
                className="team-input"
              />
            </div>
          </div>
        </div>

        <div className="team-form-actions">
          <button type="button" className="team-btn-cancel" onClick={handleBack}>
            Отмена
          </button>
          <button type="submit" className="team-btn-submit" disabled={saving}>
            {saving ? 'Сохранение...' : 'Сохранить'}
          </button>
        </div>
      </form>
    </div>
  );
};

export default EditTeamMemberPage;
